module.exports = __webpack_public_path__ + "img/Ro.81ab127a.jpg";